"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextField = exports.RootContainer = exports.ResendText = exports.CodeDiv = exports.AnchorResend = void 0;
var _mui = require("@ori-ui/mui");
const AnchorResend = exports.AnchorResend = (0, _mui.styled)('a')(({
  theme
}) => ({
  textDecoration: 'underline',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.dark
  }
}));
const StyledTextField = exports.StyledTextField = (0, _mui.styled)(_mui.TextField)({
  '& input': {
    textAlign: 'center'
  },
  margin: '0 5px',
  width: '50px',
  maxWidth: '100%',
  textAlign: 'center'
});
const RootContainer = exports.RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  maxWidth: '360px',
  marginTop: theme.spacing(10)
}));
const ResendText = exports.ResendText = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(8)
}));
const CodeDiv = exports.CodeDiv = (0, _mui.styled)('div')({
  display: 'flex',
  justifyContent: 'space-between'
});